import { render, staticRenderFns } from "./StockAdjustment.vue?vue&type=template&id=db89b47a&scoped=true"
import script from "./StockAdjustment.vue?vue&type=script&lang=js"
export * from "./StockAdjustment.vue?vue&type=script&lang=js"
import style0 from "./StockAdjustment.vue?vue&type=style&index=0&id=db89b47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db89b47a",
  null
  
)

export default component.exports